module.exports = __webpack_public_path__ + "static/media/pg19.621933b8.jpg";